module.exports = __webpack_public_path__ + "static/fabricacion-ac3bfb0e05729552dbd8b4d5e104d56b.png";